import React from 'react';
import TryhardCategoryBox from '../../TryhardCategoryBox';
import { Link } from 'react-router';
// import ComingSoonWrap from '../../../../meta/ComingSoon';

const TryhardCategories: React.FC = () => {
    return (
        <div className='flex flex-col sm:flex-row gap-y-6 gap-x-4 sm:gap-y-0 select-none'>
            <Link to='products'>
                <TryhardCategoryBox prefab='products' />
            </Link>
            <Link to='contact'>
                <TryhardCategoryBox prefab='services' />
            </Link>


        </div>
    )
}

export default TryhardCategories;